export default __webpack_public_path__ + "static/logfot-e26931b0ecb2270033d10f6de384038d.png";